<template>
  <div>

    <el-form :inline="true" :model="formInline" class="user-search">

      <el-form-item label="" prop="companyCode">
        <el-input size="mini" clearable v-model="formInline.t.companyCode" placeholder="请输入组织机构代码">
        </el-input>
      </el-form-item>
      <el-form-item label="" prop="companyCode">
        <el-input size="mini" clearable v-model="formInline.t.companyName" placeholder="请输入公司名称">
        </el-input>
      </el-form-item>
      <el-form-item label="" prop="isAvailable">
        <el-select size="mini"
                   clearable
                   v-model="formInline.t.isAvailable"
                   placeholder="是否有效">
          <el-option v-for="item in searchData.yesOrNo"
                     :key="item.value"
                     v-bind:label="item.message"
                     v-bind:value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="mini" type="primary" @click="resetSearchForm">清空</el-button>
        <el-button size="mini" type="primary" :loading='loading' icon="el-icon-search" @click="search">查询</el-button>

        <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleAdd()"
                   v-if="checkPermission(['bee:ict:cecCompanyInfo:insert'])">添加
        </el-button>
      </el-form-item>
    </el-form>

    <el-table
              @selection-change="selectChange"
              :data="userData"
              highlight-current-row
              v-loading="loading"
              border
              element-loading-text="拼命加载中"
              style="width: 100%;">


      <af-table-column prop="companyCode" label="组织机构代码">
      </af-table-column>
      <af-table-column prop="companyName" label="公司名称">
      </af-table-column>
      <af-table-column prop="companyUrl" label="对接URL">
      </af-table-column>
      <af-table-column prop="pushUrl" label="推送URL">
      </af-table-column>
      <af-table-column prop="isAvailable" label="是否有效"
                       :formatter="YesNoFormat">
      </af-table-column>
      <af-table-column prop="createTime" label="创建时间" width="160">
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span style="margin-left: 10px">{{ scope.row.createTime | formatDateFilter}}</span>
        </template>
      </af-table-column>
      <af-table-column prop="description" label="描述" width="250">
      </af-table-column>

      <af-table-column label="操作" width="180">
        <template slot-scope="scope">

          <template v-if="checkPermission(['bee:ict:cecCompanyInfo:update'])">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          </template>

          <template v-if="checkPermission(['bee:ict:cecCompanyInfo:deleteById'])">
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </template>
      </af-table-column>
    </el-table>


    <!-- 分页组件 -->
    <Pagination :child-msg="pageParam" @callFather="callFather"></Pagination>

    <!-- 添加界面 -->
    <AddPage
      :form-visible="addFormVisible"
      :searchData="searchData"
      @closeDialog="closeDialog"
      @afterAdd="afterAdd"
    ></AddPage>

    <!--修改-->
    <UpdatePage
      :form-visible="updateFormVisible"
      :searchData="searchData"
      :selectRowData="selectRowData"
      @closeDialog="closeDialog"
      @afterUpdate="afterUpdate"
    ></UpdatePage>

  </div>
</template>

<script>
    import Pagination from '@/components/Pagination.vue'
    import AddPage from '@/module/interactionCenter/page/cec/cec/add.vue'
    import UpdatePage from '@/module/interactionCenter/page/cec/cec/update.vue'
    import formatTimeToStr from '@/common/dateFormatUtil.js'
    import api from '@/module/interactionCenter/api/cec.js'
    import interfaceApi from '@/module/interactionCenter/api/interface.js'
    import commonApi from '@/common/api/commonFromVuexApi.js'

    export default {
        data() {
            return {
                addFormVisible: false,
                updateFormVisible: false,
                detailFormVisible: false,
                offVisible: false,
                onVisible: true,
                loading: false, // 是显示加载
                // 选择数据
                selectData: [],
                // 请求数据参数
                formInline: {
                    t: {
                        companyCode: ''
                    }
                },
                // 分页参数
                pageParam: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 10
                },
                // 列表数据
                userData: [],
                // 表单查询条件
                searchData: {
                    yesOrNo: [
                        {value: 'Y', message: '有效'},
                        {value: 'N', message: '无效'}
                    ],
                    interfaceNames: [],
                    stations: [],
                },

                // 选中列数据
                selectRowData: {}
            }
        },
        // 注册组件
        components: {
            AddPage,
            Pagination,
            UpdatePage
        },
        created() {
            this.search()
            this.getInterfaceNames()
            this.getStations()
        },
        filters: {
            formatDateFilter(date) {
                return formatTimeToStr(date, 'yyyy-MM-dd')
            }
        },
        watch: {},
        methods: {
            // 获取接口信息
            getInterfaceNames() {
                interfaceApi.getInterfaceNames().then((res) => {
                    if (res.data != null && res.data.length > 0) {
                        this.searchData.interfaceNames = res.data
                    }
                })
            },
            // 获取站点
            getStations() {
                commonApi.getStations().then((res) => {
                    this.searchData.stations = res
                })
            },
            YesNoFormat(row) {
                if (row.isAvailable === 'Y') {
                    return '有效'
                } else if (row.isAvailable === 'N') {
                    return '无效'
                }
            },
            handleDelete(index, row) {
                if (!row) {
                    return
                }
                    this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        api.deleteCecById(row.id).then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                this.search()
                            } else {
                                this.$message({type: 'error', message: res.message})
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            // 获取数据方法
            getData(parameter) {
                this.loading = true
                api.getCompanyInfos(JSON.stringify(parameter)).then((res) => {
                    this.userData = res.data.list
                    // 分页赋值
                    this.pageParam.currentPage = res.data.pageNum
                    this.pageParam.total = res.data.total

                    // 加载结束
                    this.loading = false
                }).catch(error => {
                    this.loading = false
                })
            }
            ,
            // 分页插件事件
            callFather() {
                let data = {
                    currentPage: this.pageParam.currentPage,
                    pageSize: this.pageParam.pageSize,
                    t: this.formInline.t
                }
                this.getData(data)
            }
            ,
            resetSearchForm() {
                this.formInline.t = {}
                this.search()
            },
            // 搜索事件
            search() {
                this.getData(this.formInline)
            }
            ,
            // 显示详情界面
            handleDetail: function (index, row) {
                if (row !== undefined) {
                    this.selectRowData = row
                    this.detailFormVisible = true
                }
            }
            ,
            // 显示编辑界面
            handleEdit: function (index, row) {
                if (row !== undefined) {
                    this.selectRowData = row
                    this.updateFormVisible = true
                }
            }
            ,
            // 添加
            handleAdd: function () {
                this.addFormVisible = true
            }
            ,
            // 选择复选框事件
            selectChange(val) {
                this.selectData = val
            }
            ,
            // 更新成功之后的操作
            afterUpdate() {
                this.updateFormVisible = false
                this.callFather()
            }
            ,
            // 添加成功后操作
            afterAdd() {
                this.addFormVisible = false
                this.search()
            }
            ,
            // 关闭弹框
            closeDialog(type) {
                console.log('type:' + type)
                if (type === 'update') {
                    this.updateFormVisible = false
                } else if (type === 'add') {
                    this.addFormVisible = false
                } else if (type === 'detail') {
                    this.detailFormVisible = false
                }
            }
            ,
            // 获取运营商
            getOperators() {
                commonApi.getOperators().then((res) => {
                    this.searchData.operators = res
                })
            }
            ,
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/interactionCenter/page/cec/cec/list.vue